import React from "react";
import { withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";
import Delete from "../../../static/images/svg/Delete.svg";
import ReactModal from "../../Common/ReactModal";
import {
  SUPER_ADMIN_LIST,
  DELETE_SUPER_ADMIN,
} from "../../../services/graphql/queries/superAdmin";
import {
  SET_TIMEOUT_VALUE,
  dateFormatMonth,
} from "../../../constants/app-constants";
import { format } from "date-fns";
class SuperAdminList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      superAdminlist: [],
      modalMessage: "Are you sure Do you want to delete",
      reactModalVisible: false,
      error: "",
      id: "",
      loading: true,
    };
  }

  submitModal = () => {
    this.deleteSuperAdmin();
  };
  closeModal = () => {
    this.setState({ reactModalVisible: false });
  };
  deleteSuperAdmin = () => {
    debugger;
    this.props.client
      .mutate({
        mutation: DELETE_SUPER_ADMIN,
        variables: {
          id: this.state.id,
        },
        fetchPolicy: "no-cache",
      })
      .then((result) => {
        this.getListOfSuperAdmins();
        this.setState({ reactModalVisible: false });
      })
      .catch((error) => {
        console.log("~~~error: ", error);
        this.setState({ loading: false, error: error.message });
      });
  };
  getListOfSuperAdmins = () => {
    this.props.client
      .query({
        query: SUPER_ADMIN_LIST,
        fetchPolicy: "network-only",
      })
      .then((result) => {
        console.log("result", result);
        this.setState({
          superAdminlist: result.data.getListOfSuperAdmins,
          loading: false,
          error: "",
        });
      })
      .catch((error) => {
        console.log("~~~error: ", error);
        this.setState({ loading: false, error: error.message });
      });
  };
  delete(e, id) {
    this.setState({
      id: id,
      reactModalVisible: true,
      requireCancel: true,
    });
  }
  componentDidMount() {
    this.getListOfSuperAdmins();
  }
  render() {
    const {
      reactModalVisible,
      modalMessage,
      superAdminlist,
      loading,
      error,
    } = this.state;
    if (loading) return <>loading !!!</>;
    if (error) return <>error !!!</>;
    return (
      <>
        <ReactModal
          reactModalVisible={reactModalVisible}
          closeModal={this.closeModal}
          submitModal={this.submitModal}
          modalMessage={modalMessage}
          requireCancel={true}
        />
        <div className="row align-items-center no-gutters">
          <div className="col-md-6">
            <h1 className="heading m-b-0"> Super Admin List</h1>
          </div>

          <div className="col-md-6 text-right">
            <button
              className="btn btn-danger"
              onClick={() => {
                this.props.history.push("/super-admin-add");
              }}
            >
              Add
            </button>
          </div>
        </div>
        <div className="table-responsive">
          <table className="table table-style-1 ">
            <thead>
              <tr>
                {/* <th scope="col">ID</th> */}
                <th scope="col">ID</th>
                <th scope="col">NAME</th>
                <th scope="col">USER TYPE</th>
                <th scope="col">PORTAL</th>
                <th scope="col">CREATED BY</th>
                <th scope="col">CREATED ON</th>
                <th scope="col">ACTION</th>
              </tr>
            </thead>
            <tbody>
              {superAdminlist.length
                ? superAdminlist.map((data, index) => {
                    return (
                      <tr key={index}>
                        <td>{data.userId ? data.userId.Id : ""} </td>
                        <td>{data.name} </td>
                        <td>
                          {data.userId && data.userId.entityType == 2
                            ? " Jakson Green User"
                            : data.userId.entityType == 1
                            ? "External User"
                            : ""}{" "}
                        </td>
                        <td>
                          {data.portalType == 4
                            ? "Info Portal (BD)"
                            : ""}
                        </td>
                        <td>{data.createdBy ? data.createdBy.loginId : ""}</td>
                        <td>
                          {data.createdOn
                            ? format(data.createdOn, dateFormatMonth)
                            : ""}
                        </td>

                        <td>
                          <a
                            href="#"
                            className="link-primary  "
                            data-toggle="tooltip"
                            data-placement="bottom"
                            title="Delete"
                            onClick={(e) => {
                              this.delete(e, data.id);
                            }}
                          >
                            <img src={Delete} />
                          </a>
                        </td>
                      </tr>
                    );
                  })
                : null}
            </tbody>
          </table>
          {!superAdminlist.length && error ? <div>{error}</div> : null}
          {!superAdminlist.length && loading ? <div>Fetching...</div> : null}
          {!superAdminlist.length && !error && !loading ? (
            <div style={{ textAlign: "center" }}>No Data</div>
          ) : null}
        </div>
      </>
    );
  }
}

export default withRouter(withApollo(SuperAdminList));
